import React from 'react';
import { Mail, Phone, Facebook, Youtube, Globe, Home } from 'lucide-react';
import logoIcon from '../assets/images/logo_icon_trắng.png';
import { useFooter } from '../hooks/useFooter';

const Footer: React.FC = () => {
  const footer = useFooter();

  return (
    <footer className="footer-main">
      <div className="container-custom">
        {/* Main Footer Content */}
        <div className="footer-content">
          <div className="footer-grid-new">
            {/* Left Column - Company Info */}
            <div className="footer-section-left">
              <div className="footer-company-content">
                <div className="footer-logo-new">
                  <div className="footer-logo-icon-new">
                    <img src={logoIcon} alt="TUKI GROUP Logo" className="footer-logo-image" />
                  </div>
                </div>
                <div className="footer-company-info">
                  <h3 className="footer-company-name-new">{footer.companyName}</h3>
                  <div className="footer-company-details-new">
                    <p className="footer-company-tax">Mã số thuế: {footer.taxNumber}</p>
                    <p className="footer-company-date">Ngày cấp: {footer.issueDate}</p>
                    <p className="footer-company-issuer">Nơi cấp: {footer.issuer}</p>
                    <p className="footer-company-representative">Người đại diện: {footer.representative}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Info */}
            <div className="footer-section-right">
              <div className="footer-contact-new">
                {footer.addresses.map((addr, i) => (
                  <div className="footer-contact-item-new" key={i}>
                    {i === 0 ? (
                      <Home className="footer-contact-icon-new" />
                    ) : (
                      <div className="footer-contact-icon-new" />
                    )}
                    <p className="footer-contact-value-new">{addr}</p>
                  </div>
                ))}
                <div className="footer-contact-item-new">
                  <Phone className="footer-contact-icon-new" />
                  <p className="footer-contact-value-new">{footer.phone}</p>
                </div>
                <div className="footer-contact-item-new">
                  <Mail className="footer-contact-icon-new" />
                  <p className="footer-contact-value-new">{footer.email}</p>
                </div>
                <div className="footer-contact-item-new">
                  <Globe className="footer-contact-icon-new" />
                  <a href={footer.websiteUrl} target="_blank" rel="noopener noreferrer" className="footer-contact-value-new footer-link">
                    {footer.websiteLabel}
                  </a>
                </div>
              </div>
              <div className="footer-social-new">
                <a href={footer.facebookUrl} target="_blank" rel="noopener noreferrer" className="footer-social-link-new">
                  <Facebook className="footer-social-icon-new" />
                </a>
                <a href={footer.zaloUrl} target="_blank" rel="noopener noreferrer" className="footer-social-link-new">
                  <span className="zalo-icon">Zalo</span>
                </a>
                <a href={footer.youtubeUrl} target="_blank" rel="noopener noreferrer" className="footer-social-link-new">
                  <Youtube className="footer-social-icon-new" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section - Copyright */}
        <div className="footer-bottom-new">
          <div className="footer-bottom-content-new">
            <p className="footer-copyright-new">
              {footer.copyright} | {footer.description}
            </p>
          </div>
        </div>
      </div>

      {/* Call button */}
      <a href={`tel:${footer.hotline}`} className="back-to-top">
        <Phone className="back-to-top-icon" />
      </a>
    </footer>
  );
};

export default Footer;
